import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { PostAppGroupIdBrazeDocsFallbackSearchResult } from "./types";

export const isPostAppGroupIdBrazeDocsFallbackSearchResult = objectOf<PostAppGroupIdBrazeDocsFallbackSearchResult>({
  results: string,
});
